/**
 * Flickity carousel — laptop trackpad horizontal scroll support.
 * Flickity handles mouse drag and touch; trackpads emit wheel events instead.
 * @see https://flickity.metafizzy.co/
 */
(function () {
  const CAROUSEL_SELECTOR = '.carousel.flickity-enabled';
  const wheelSnapTimeouts = new WeakMap();
  const wheelFadeAccumulated = new WeakMap();

  function getHorizontalDelta(event) {
    let deltaX = event.deltaX;
    const deltaY = event.deltaY;

    if (event.shiftKey && Math.abs(deltaY) > Math.abs(deltaX)) {
      deltaX = deltaY;
    }

    if (Math.abs(deltaX) <= Math.abs(deltaY) || deltaX === 0) {
      return null;
    }

    return deltaX;
  }

  function handleFadeWheel(flkty, deltaX, viewport) {
    const scrollDelta = flkty.options.rightToLeft ? deltaX : -deltaX;
    const threshold = 30;
    let accumulated = wheelFadeAccumulated.get(viewport) || 0;

    accumulated += scrollDelta;

    if (Math.abs(accumulated) < threshold) {
      wheelFadeAccumulated.set(viewport, accumulated);
      return;
    }

    wheelFadeAccumulated.set(viewport, 0);

    if (accumulated < 0) {
      flkty.next();
    } else {
      flkty.previous();
    }
  }

  function handleScrollWheel(flkty, deltaX, viewport) {
    const scrollDelta = flkty.options.rightToLeft ? deltaX : -deltaX;

    flkty.x += scrollDelta;
    flkty.velocity = 0;

    if (!flkty.options.wrapAround && flkty.slides.length) {
      const minX = -flkty.getLastSlide().target;
      const maxX = -flkty.slides[0].target;

      if (flkty.x < minX) {
        flkty.x = minX - (minX - flkty.x) * 0.25;
      } else if (flkty.x > maxX) {
        flkty.x = maxX + (flkty.x - maxX) * 0.25;
      }
    }

    flkty.positionSlider();

    clearTimeout(wheelSnapTimeouts.get(viewport));
    wheelSnapTimeouts.set(
      viewport,
      setTimeout(function () {
        flkty.select(flkty.dragEndRestingSelect());
      }, 120)
    );
  }

  function enableTrackpadScroll(carousel) {
    if (typeof Flickity === 'undefined') {
      return;
    }

    const flkty = Flickity.data(carousel);

    if (!flkty || !flkty.isDraggable || carousel.dataset.trackpadScrollEnabled === 'true') {
      return;
    }

    carousel.dataset.trackpadScrollEnabled = 'true';

    flkty.viewport.addEventListener('wheel', function (event) {
      const deltaX = getHorizontalDelta(event);

      if (deltaX === null) {
        return;
      }

      event.preventDefault();

      if (flkty.options.fade) {
        handleFadeWheel(flkty, deltaX, flkty.viewport);
        return;
      }

      handleScrollWheel(flkty, deltaX, flkty.viewport);
    }, { passive: false });
  }

  window.clubCuveeInitTrackpadScroll = function (flkty, carousel) {
    if (flkty && carousel) {
      enableTrackpadScroll(carousel);
    }
  };

  window.clubCuveeInitFeaturedCollectionTrackpad = window.clubCuveeInitTrackpadScroll;

  function initTrackpadScroll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(CAROUSEL_SELECTOR).forEach(function (carousel) {
      enableTrackpadScroll(carousel);
    });
  }

  function init() {
    initTrackpadScroll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setTimeout(function () {
      initTrackpadScroll(event.target);
    }, 0);
  });
})();
